const filterDefinitions = {
  userId: {
    id: 'userId',
    label: 'User',
  },
  locationId: {
    id: 'locationId',
    label: 'Location',
  },
  servicePersonId: {
    id: 'servicePersonId',
    label: 'Service Person',
  },
  todoTypeId: {
    id: 'todoTypeId',
    label: 'Type',
  },
  todoStatusId: {
    id: 'todoStatusId',
    label: 'Status',
  },
  search: {
    id: 'search',
    label: 'Search',
  },
  serviceId: {
    id: 'serviceId',
    label: 'Service Interest',
  },
  datePicker: {
    id: 'datePicker',
    label: 'Date Picker',
  },
};

export default filterDefinitions;
